import React from 'react';
import {
  IconBoxIconType,
  ImageContainer,
  Label,
  Line,
  WrapperBox,
} from './IconBox.style-elements';

export interface IconBoxProps {
  iconType?: IconBoxIconType;
}

const IconBox: React.FC<IconBoxProps> = ({ iconType, children }) => {
  return (
    <WrapperBox>
      <ImageContainer iconType={iconType} component="i" />
      <Line />
      <Label>{children}</Label>
    </WrapperBox>
  );
};

export default IconBox;
